/**
 * handlers/notifications.ts
 * Notification settings: load, save, sync to UI.
 */

import { state } from '../state';
import {
  getNotificationSettings   as apiGetNotificationSettings,
  updateNotificationSettings as apiUpdateNotificationSettings,
} from '../api';
import { showToast } from '../ui-renderers';

function _syncNotificationSettingsUI(settings: Record<string, any>) {
  const briefingEl = document.getElementById('ai-notif-briefing-time') as HTMLSelectElement | null;
  const deadlineEl = document.getElementById('ai-notif-deadline-reminders') as HTMLInputElement | null;
  const digestEl   = document.getElementById('ai-notif-weekly-digest') as HTMLInputElement | null;
  if (briefingEl && settings.briefing_time !== undefined)       briefingEl.value   = settings.briefing_time;
  if (deadlineEl && settings.deadline_reminders !== undefined)  deadlineEl.checked = settings.deadline_reminders;
  if (digestEl   && settings.weekly_digest !== undefined)       digestEl.checked   = settings.weekly_digest;
}

/**
 * Load notification settings from API into state and the settings UI.
 */
export async function loadNotificationSettings() {
  try {
    const data = await apiGetNotificationSettings();
    state.notificationSettings = data.settings || {};
    _syncNotificationSettingsUI(state.notificationSettings);
  } catch (_) { /* best effort */ }
}

/**
 * Save a single notification setting field to the backend.
 */
export async function handleNotificationSettingChange(field: string, value: any) {
  const patch = { [field]: value };
  state.notificationSettings = { ...state.notificationSettings, ...patch };
  try {
    await apiUpdateNotificationSettings(patch);
  } catch (_) {
    showToast('Could not save notification setting.', 'error');
  }
}
